// Typelizer digest 72e0487e2dd8355be62500c7b0a2cfbe
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /learners/students/:student_id/classes */
  index: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:student_id/classes', params, options),
    method: 'get',
  }),
}
